import { useEffect, useState } from 'react';

import { slugify } from '~utils/string';
import getMobileOperatingSystem from '~utils/userAgent';
import { setCookie, getCookie } from '~utils/cookies';

import { expiredDateInUTC } from './../utils';
import { appStores } from './../constants';
import { smartbarnnerClosed, smartbarnnerInstalled } from './constants';

const useSmartBanner = ({
  appsLinks,
  daysHidden,
  daysReminder,
  onClose,
  onInstall,
  setIsSmartbannerActive
}) => {
  const isClient = typeof window !== 'undefined';
  const userAgent = slugify(getMobileOperatingSystem());
  const smartBannerClosedCookie = getCookie(smartbarnnerClosed);
  const smartBannerInstalled = getCookie(smartbarnnerInstalled);
  const [ableToShow, setAbleToShow] = useState(false);
  const [isSmartbannerOpen, setIsSmartbannerOpen] = useState(false);
  const appLink = appsLinks[appStores[userAgent]];
  const install = () => {
    hide();
    setCookie(smartbarnnerInstalled, 'true', expiredDateInUTC(daysReminder));
    if (isClient) {
      window.location.href = appLink;
    }
    if (onInstall && typeof onInstall === 'function') {
      onInstall();
    }
  };

  const hide = () => {
    if (isClient) {
      setIsSmartbannerOpen(false);
    }
  };

  const close = () => {
    hide();
    setCookie(smartbarnnerClosed, 'true', expiredDateInUTC(daysHidden));

    if (onClose && typeof onClose === 'function') {
      onClose();
    }
  };

  useEffect(() => {
    const show = () => {
      if (isClient) {
        setIsSmartbannerOpen(true);
      }
    };
    show();
  }, [appLink, isClient, onInstall, setIsSmartbannerOpen, smartBannerInstalled]);

  useEffect(() => {
    const conditionToShow =
      isClient && !smartBannerClosedCookie && !smartBannerInstalled && isSmartbannerOpen && appLink;
    setAbleToShow(conditionToShow);
    setIsSmartbannerActive(conditionToShow);
  }, [
    smartBannerClosedCookie,
    isSmartbannerOpen,
    appLink,
    smartBannerInstalled,
    isClient,
    setIsSmartbannerOpen,
    setIsSmartbannerActive
  ]);
  return {
    ableToShow,
    appLink,
    install,
    hide,
    close
  };
};

export default useSmartBanner;
